import clsx from "clsx";
import { FunctionComponent } from "react";

import * as styles from "@ui/components/article/ShareButtons/components/ShareButtonsSharePopover/ShareButtonsSharePopover.css";
import * as shareButtonsStyles from "@ui/components/article/ShareButtons/ShareButtons.css";
import WhatsappIcon from "@ui/components/icon/social/WhatsappIcon";
import { useAnalytics } from "@voxmedia/duet-context/context/analytics-context";

interface Props {
  url: string;
  title: string;
  onPopoverClose: () => void;
}

/**
 * WhatsApp share button component for the share popover
 */
const ShareButtonsWhatsappPopover: FunctionComponent<Props> = ({
  url,
  title,
  onPopoverClose,
}) => {
  const analytics = useAnalytics();

  const handleWhatsAppShare = () => {
    analytics?.emit({
      event: "social_share",
      social_share: { platform: "whatsapp" },
    });

    const encodedUrl = encodeURIComponent(url);
    const encodedTitle = encodeURIComponent(title);
    const whatsappUrl = `https://api.whatsapp.com/send?text=${encodedTitle}%20${encodedUrl}`;
    window.open(
      whatsappUrl,
      "share_whatsapp",
      "width=658, height=354, scrollbars=no",
    );
    onPopoverClose();
  };

  return (
    <button
      onClick={handleWhatsAppShare}
      className={styles.shareOption}
      aria-label="Share on WhatsApp"
    >
      <span
        className={clsx(
          shareButtonsStyles.button.standard,
          styles.shareIconContainer,
        )}
      >
        <WhatsappIcon className={styles.shareIcon} />
      </span>
      <span className={styles.shareLabel}>WhatsApp</span>
    </button>
  );
};

export default ShareButtonsWhatsappPopover;
